var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('button',{staticClass:"btn btn-sm btn-outline-primary ms-2 py-0 px-2 align-middle",attrs:{"type":"button","title":_vm.title,"aria-label":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.openTracking.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-eye",attrs:{"aria-hidden":"true"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }